






































import TeacherInfoPage from './TeacherInfoPage.vue';
import TeacherCommunication2Page from './TeacherCommunication2Page.vue';
import TeacherInputCofirmPage from './TeacherInputCofirmPage.vue';
import TeacherLeadershipPage from './TeacherLeadershipPage.vue';
import TeacherMotivationPage from './TeacherMotivationPage.vue';

import RequiresAnnounce from '../../components/atoms/RequiresAnnounce.vue';
import { Session } from '../../utils/Session';
import { TeacherInfoInputDTO } from '../../../src_server/entity/dto/TeacherInfoInputDTO';
import { Vue, Component } from 'vue-property-decorator';
import { PageValidate } from '../../utils/PageValidate';
import { InputPages } from '../../components/organisms/InputPages';
import { MessageDialog } from '../../utils/MessageDialog';
import { TeacherService } from '../../biz/remote/TeacherService';
import { FileUpload } from '../../biz/FileUpload';
import { schoolYearsData } from '../../../src_server/entity/master/schoolYearsData';
import { subjectsData } from '../../../src_server/entity/master/subjectsData';
import { routeHelper } from '../../utils/routeHelper';
import { scrollToTop } from '../../utils/viewAction';

@Component({
  components: {
    TeacherInfoPage,
    TeacherCommunication2Page,
    TeacherLeadershipPage,
    TeacherMotivationPage,
    TeacherInputCofirmPage,
    RequiresAnnounce,
  },
})
export default class TeacherInfoInputMain extends Vue {
  info: TeacherInfoInputDTO = new TeacherInfoInputDTO();
  iconImageFile?: File;
  private loadig = false;

  currentPage = 0;

  get all() {
    return !this.hasNext;
  }

  get forDisplay() {
    return !this.hasNext;
  }

  pageTitles = [
    { index: '0', name: 'TeacherInfoPage', title: '個人情報の入力' },
    { index: '1', name: 'TeacherCommunication2Page', title: 'コミュニケーション手段の入力' },
    { index: '2', name: 'TeacherLeadershipPage', title: '指導者情報の入力' },
    { index: '3', name: 'TeacherMotivationPage', title: '応募動機の入力' },
    { index: '4', name: 'TeacherInputCofirmPage', title: '入力確認' },
  ];

  get title() {
    return `${this.pageTitles[this.currentPage].title}(${this.currentPage + 1}/${this.pageTitles.length})`;
  }

  save() {
    // セッション上に保存
    Session.set<TeacherInfoInputDTO>('TEACHER_INFO_INPUTING', this.info);
  }

  backPage() {
    scrollToTop();

    this.currentPage--;
    this.save();
  }

  onUploadFile(value: any) {
    console.log('onUploadFile', value);
    this.info.files = value;
  }

  get hasNext(): boolean {
    return this.pageTitles.length > this.currentPage + 1;
  }

  next() {
    const pageName = this.pageTitles[this.currentPage].name;
    const page = this.$refs[pageName] as InputPages;

    if (!PageValidate.validate(page.$refs) && page.validate()) {
      scrollToTop();
      // エラーがなければ保存して進む
      this.save();
      this.currentPage++;
    } else {
      scrollToTop();
    }
  }

  updated() {
    console.log(this.info);
    this.save();
  }

  mounted() {
    this.pageTitles.forEach((page) => {
      (this.$refs[page.name] as InputPages).title = this.pageTitles.filter((p) => p.name === page.name)[0].title;
    });
  }

  created() {
    // 途中のデータを取り出す
    console.log(this.info);
    let sessionDto = Session.get<TeacherInfoInputDTO>('TEACHER_INFO_INPUTING');
    // 初回だったらデフォルト値
    if (!sessionDto) {
      sessionDto = new TeacherInfoInputDTO();
      // sessionDto.teacher.target_school_year = schoolYearsData.join(',');
      // sessionDto.teacher.subject = subjectsData.join(',');
    }
    this.info = sessionDto;
  }

  register() {
    this.save();
    MessageDialog.confirm('登録しますよろしいですか？').then(async (result) => {
      if (!result) {
        return;
      }
      this.loadig = true;

      const service = new TeacherService();
      const infoResponse = await service.setTeacherInfo(this.info, Session.getSessionBuildingId());
      if (infoResponse.hasError) {
        MessageDialog.alert(`登録時にエラーが発生しました。${infoResponse.errorDescription}`).then();
        this.loadig = false;
      }
      if (!infoResponse.data.userAuth.user_id) {
        MessageDialog.alert(`ユーザーIDが正しく取得できませんでした。`).then();
        this.loadig = false;
        return;
      }
      const user_id = infoResponse.data.userAuth.user_id;
      const biz = new FileUpload();

      // アイコン写真のアップロード
      if (this.info.files.icon_image_file) {
        console.log('before upload user_id', user_id);
        await biz.fileUpload(user_id, 'teacher_icon', this.info.files.icon_image_file);
      }

      // // ムービーのアップロード
      // if (this.info.files.movie_file) {
      //   console.log('before upload user_id', user_id);
      //   await biz.fileUpload(user_id, 'movie_for_selection', this.info.files.movie_file);
      // }

      // MessageDialog.alert('お申し込みを受け付けました。面接のご返信まで、しばらくお待ちください。').then(() => );
      this.loadig = false;
      routeHelper(this, 'TeacherRegistComplete');
    });
  }
}
